<template>
  <BodyWrapper>
    <div
      id="settings-app"
      class="body-wrapper m-0 mb-10 px-6 py-2 max-w-xl"
    >
      <div
        v-if="!hasProPlan"
      >
        <CustomDomainStarters />
      </div>

      <div
        v-else-if="hasProPlan"
      >
        <CustomDomainPro />
      </div>
    </div>
  </BodyWrapper>
</template>

<script>
import { mapGetters } from 'vuex';
import BodyWrapper from '@/components/layout/BodyWrapper';
import CustomDomainStarters from './CustomDomainStarters.vue';
import CustomDomainPro from './CustomDomainPro.vue';

export default {
  name: 'CustomDomain',
  components: {
    BodyWrapper,
    CustomDomainStarters,
    CustomDomainPro,
  },
  computed: {
    ...mapGetters([
      'app',
    ]),
    hasProPlan() {
      return this.app?.account?.product_plan.level >= 2;
    },
  },
};
</script>

<style scoped>
</style>
